import useMedia from 'use-media';

const useMediaWidth = () => useMedia({ maxWidth: '920px' });

export default useMediaWidth;
